module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticStyle: {
      "background": "url(../../../static/user/center/主页顶部.jpg)",
      "width": "100%",
      "color": "white",
      "font-size": "0.34rem",
      "overflow": "hidden",
      "background-size": "cover"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "0.2rem"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33%",
      "font-size": "0.4rem"
    }
  }, [_vm._v("我")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33%",
      "font-size": "0.32rem",
      "padding-top": "0.1rem",
      "padding-right": "0.3rem"
    },
    attrs: {
      "align": "right"
    },
    on: {
      "click": _vm.qiandao
    }
  }, [(this.g_UserInfo.isSignInedToday) ? _c('div', [_vm._v("已签到")]) : _vm._e(), _vm._v(" "), (!this.g_UserInfo.isSignInedToday) ? _c('div', [_vm._v("签到")]) : _vm._e()])])])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "1.6rem",
      "padding": "0.7rem 0 0.4rem 0.3rem",
      "float": "left"
    },
    attrs: {
      "src": require("../../../static/user/center/主页头像.png")
    },
    on: {
      "click": _vm.goBaseInfo
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "padding": "0.9rem 0 0 0.4rem"
    },
    attrs: {
      "align": "left"
    },
    on: {
      "click": _vm.goBaseInfo
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.UserName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.24rem",
      "color": "#94e588",
      "margin-top": "0.1rem"
    }
  }, [_vm._v("基本信息 >")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('mu-chip', {
    staticStyle: {
      "background-color": "#FFBF3B",
      "color": "white",
      "margin-top": "1rem",
      "width": "2.1rem",
      "margin-right": "-0.3rem",
      "font-size": "0.26rem"
    },
    on: {
      "click": function($event) {
        return _vm.goVipCard()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto 0 auto"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "0.05rem",
      "width": "0.26rem",
      "margin-bottom": "-0.05rem"
    },
    attrs: {
      "src": require("../../../static/user/vipcard/CardLeft.png")
    }
  }), _vm._v("\n          " + _vm._s(_vm.CardType) + "\n          "), _c('img', {
    staticStyle: {
      "width": "0.26rem",
      "margin-bottom": "-0.05rem",
      "margin-right": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/user/vipcard/CardRight.png")
    }
  })])])], 1)]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin-top": "2vh",
      "font-size": "0.18rem"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "0.26rem"
    }
  }, [_c('nobr', [_vm._v("我的特权")])], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), (_vm.g_UserInfo.Card_Kind_Diplay == '数字卡') ? _c('div', {
    staticClass: "ALLtequan"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.g_UserInfo.Card_Kind_Diplay == '贵宾卡') ? _c('div', {
    staticClass: "ALLtequan"
  }, [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.g_UserInfo.Card_Kind_Diplay == '贝壳卡') ? _c('div', {
    staticClass: "ALLtequan"
  }, [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21)]) : _vm._e(), _vm._v(" "), (_vm.g_UserInfo.Card_Kind_Diplay == '金卡') ? _c('div', {
    staticClass: "ALLtequan"
  }, [_vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29)]) : _vm._e(), _vm._v(" "), (_vm.g_UserInfo.Card_Kind_Diplay == '铂金卡') ? _c('div', {
    staticClass: "ALLtequan"
  }, [_vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37)]) : _vm._e(), _vm._v(" "), (_vm.g_UserInfo.Card_Kind_Diplay == '员工卡') ? _c('div', {
    staticClass: "ALLtequan"
  }, [_vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41)]) : _vm._e(), _vm._v(" "), (_vm.g_UserInfo.Card_Kind_Diplay == '翡翠卡') ? _c('div', {
    staticClass: "ALLtequan"
  }, [_vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46)]) : _vm._e(), _vm._v(" "), (_vm.g_UserInfo.Card_Kind_Diplay == '联名卡') ? _c('div', {
    staticClass: "ALLtequan"
  }, [_vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "greyline",
    staticStyle: {
      "background-color": "#F5F5F5",
      "height": "1.5vh"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mList"
  }, [_c('div', {
    staticClass: "mItem",
    on: {
      "click": function($event) {
        return _vm.goMyCollection()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/user/Entrance/collect.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("我的收藏")])]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "mItem",
    on: {
      "click": _vm.goMyComments
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/user/Entrance/comment.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("我的点评")])]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "mItem",
    on: {
      "click": function($event) {
        return _vm.goInvoiceManage()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/user/Entrance/invoice.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("发票管理")])]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "mItem",
    on: {
      "click": function($event) {
        return _vm.goBreakfast()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/user/Entrance/breakfast.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("我的早餐券")])]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "mItem",
    on: {
      "click": _vm.goCheckInMan
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/user/Entrance/resident.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("常住人员管理")])]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "mItem",
    on: {
      "click": function($event) {
        return _vm.goFreeVo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/user/Entrance/freeVo.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("我的免房券")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "greyline",
    staticStyle: {
      "background-color": "#F5F5F5",
      "height": "1.5vh"
    }
  }), _vm._v(" "), _c('mu-list-item', {
    staticStyle: {
      "font-size": "0.32rem"
    },
    on: {
      "click": _vm.goLogout
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#FF5A5A"
    }
  }, [_vm._v("退出当前用户")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "1.5rem",
      "background-color": "#F5F5F5"
    }
  }), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": this.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('pop', {
    attrs: {
      "display": _vm.popDisplayU,
      "title": "提示",
      "msg": _vm.popMsg,
      "onlyOk": _vm.popOnlyOk
    },
    on: {
      "closeHandler": _vm.closePop,
      "okHandler": _vm.closeYESU
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #e2e2e2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/打折.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("9.5折\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/积分.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("积1倍K币\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/退房.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("13:00退房\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/代金券.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("电子代金券\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/99特惠.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("998特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/生日.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("生日礼物\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/打折.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("9.2折\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/积分.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("积2倍K币\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/退房.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("13:00退房\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/代金券.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("电子代金券\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/99特惠.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("998特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/生日.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("生日礼物\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/同行.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("同行特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/积分.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("积12倍K币\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/退房.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("14:00退房\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/代金券.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("电子代金券\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/69特惠.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("69特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/生日.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("生日礼物\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/同行.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("同行特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/免押金.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("免押金\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/打折.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("8.8折\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/积分.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("积2.5倍K币\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/退房.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("14:00退房\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/代金券.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("电子代金券\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/99特惠.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("998特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/生日.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("生日礼物\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/同行.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("同行特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/免押金.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("免押金\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/打折.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("8.5折\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/积分.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("积3倍K币\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/退房.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("14:00退房\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/代金券.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("电子代金券\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/99特惠.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("998特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/生日.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("生日礼物\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/同行.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("同行特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/免押金.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("免押金\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/打折.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("7折\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/退房.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("13:00退房\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/同行.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("同行特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/免押金.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("免押金\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/打折.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("7折\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/积分.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("积3倍K币\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/退房.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("14:00退房\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/同行.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("同行特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/免押金.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("免押金\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/打折.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("折扣\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/积分.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("积分\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/退房.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("延时退房\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/代金券.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("电子代金券\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/99特惠.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("998特惠\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/生日.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("生日礼物\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tequan"
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/user/center/同行.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("同行特惠\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2e0685e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserCenter.vue
// module id = 1605
// module chunks = 18